import React, {useState} from 'react';
import {Button, useNotify, useRefresh, useUnselectAll, useDataProvider, useQueryWithStore} from "react-admin";
import Popover from "@material-ui/core/Popover";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import SyncIcon from "@material-ui/icons/Sync";

const SetCurrentBankPopover = props => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedBank, setSelectedBank] = useState('');
    const {selectedIds} = props;
    const notify = useNotify();
    const refresh = useRefresh();
    const dataProvider = useDataProvider();
    const unselectAll = useUnselectAll();

    const { data: banks } = useQueryWithStore({
        type: 'getList',
        resource: 'companyBanks',
        payload: { filter: { expand: 'bank' }, pagination: {}, sort: {} }
    });

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMove = async () => {
        setLoading(true);
        try {
            // Fetch all selected employees with their bank accounts
            const { data: employees } = await dataProvider.getMany('employees', { ids: selectedIds, expand: 'bankAccounts' });
            
            const results = { success: [], notFound: [] };
            
            // Process each employee
            for (const employee of employees) {
                const matchingAccount = (employee.bankAccounts || []).find(acc => acc.companyBankId === selectedBank);
                
                if (matchingAccount) {
                    await dataProvider.update('employees', {
                        id: employee.id,
                        data: {
                            companyBankId: matchingAccount.companyBankId,
                            bankAccountNumber: matchingAccount.bankAccountNumber,
                            bankBranch: matchingAccount.bankBranch,
                            bankAccountHolderName: matchingAccount.bankAccountHolderName
                        }
                    });
                    results.success.push(employee.fullname || employee.name);
                } else {
                    results.notFound.push(employee.fullname || employee.name);
                }
            }

            // Show results
            if (results.success.length > 0) {
                notify(`Successfully updated bank details for ${results.success.length} employee(s)`, 'info');
            }
            if (results.notFound.length > 0) {
                notify(`No matching bank account found for: ${results.notFound.join(', ')}`, 'warning');
            }

            refresh();
            unselectAll('employees');
            handleClose();
        } catch (error) {
            notify('Error updating bank details', 'error');
        }
        setLoading(false);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            <Button label={props.label} aria-describedby={id} variant="text" color="primary" onClick={handleClick}>
                <SyncIcon/>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Card style={{minWidth: 300}}>
                    <CardContent>
                        <FormControl margin='normal'>
                            <InputLabel shrink>
                                Select Bank
                            </InputLabel>
                            <Select
                                value={selectedBank}
                                onChange={ev => {
                                    setSelectedBank(ev.target.value)
                                }}
                            >
                                {banks && banks.map(bank => (
                                    <MenuItem key={bank.id} value={bank.id}>
                                        {bank.bank ? bank.bank.name : ''}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </CardContent>
                    <CardActions>
                        <Button
                            label='OK'
                            disabled={loading || !selectedBank}
                            style={{marginLeft: 'auto'}}
                            onClick={handleMove}
                            variant="text"
                            color="primary"
                        />
                    </CardActions>
                </Card>
            </Popover>
        </div>
    );
};

export default SetCurrentBankPopover; 